import React from 'react'
import { Grid } from '@mui/material'
import NunitoText from './NunitoText'
export default function NoData({ height, text }) {
    return (
        <Grid container justifyContent='center' alignItems='center' style={{ height }}>
            <NunitoText value={text || 'No data available'} fontSize={25} />
        </Grid>
    )
}